<template>
  <div class="jycfg-page">
    <x-table
      new-style
      :no-data-text="CA('jybk_check') ? '暂无数据' : '暂无数据查询权限'"
      :columns="table.columns"
      :data="table.data"
      :loading="table.loading"
      :config="config"
      @add="add"
      @search="search"
      @page-change="pageChange"
    >
    </x-table>

    <Modal
      v-model="modal.show"
      :title="modal.title"
      @on-visible-change="modalShow"
    >
      <Form ref="form" :model="form" :rules="rules" :label-width="100">
        <FormItem label="一体机" prop="aio">
          <Select v-model="form.aio" clearable style="width: 300px">
            <Option
              v-for="(item, index) in ytjList"
              :value="item.value + '/' + item.label"
              :key="index"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="板卡名称" prop="name">
          <Input v-model="form.name" style="width: 300px"></Input>
        </FormItem>
        <FormItem label="AI通道数" prop="aiCount">
          <Input v-model="form.aiCount" style="width: 300px"></Input>
        </FormItem>
        <FormItem label="AO通道数" prop="aoCount">
          <Input v-model="form.aoCount" style="width: 300px"></Input>
        </FormItem>
        <FormItem label="DI通道数" prop="diCount">
          <Input v-model="form.diCount" style="width: 300px"></Input>
        </FormItem>
        <FormItem label="DO通道数" prop="doCount">
          <Input v-model="form.doCount" style="width: 300px"></Input>
        </FormItem>
        <FormItem label="板卡KEY" prop="deviceKey">
          <Input v-model="form.deviceKey" style="width: 300px"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            style="width: 300px"
          ></Input>
        </FormItem>
      </Form>
      <p slot="footer">
        <Button type="primary" :loading="modal.submitLoading" @click="submit"
          >提交</Button
        >
        <Button @click="() => (modal.show = false)">取消</Button>
      </p>
    </Modal>
  </div>
</template>

<script>
import CU from "@/common/util";
import { Switch } from "view-design";
import jycfgTb from "./jycfgTb";
export default {
  name: "",
  props: {
    farmOptions: Array,
    aioGuid: String,
    ytjList: Array,
  },
  components: {
    jycfgTb,
  },
  data() {
    return {
      table: {
        columns: [
          {
            type: "expand",
            width: 60,
            render: (h, { row }) => {
              return row.id ? (
                <jycfgTb props={{ jyObj: row }}></jycfgTb>
              ) : (
                <span>--</span>
              );
            },
          },
          {
            title: "所属设备",
            minWidth: 100,
            key: "aioName",
          },
          {
            title: "板卡名称",
            minWidth: 100,
            key: "name",
          },
          {
            title: "AI通道数",
            width: 100,
            key: "aiCount",
          },
          {
            title: "AO通道数",
            width: 100,
            key: "aoCount",
          },
          {
            title: "DI通道数",
            width: 100,
            key: "diCount",
          },
          {
            title: "DO通道数",
            width: 100,
            key: "doCount",
          },
          {
            title: "板卡KEY",
            minWidth: 100,
            key: "deviceKey",
          },
          // {
          //   title: "连接状态",
          //   width: 100,
          //   key: "clientStatusName",
          // },
          // {
          //   title: "UDP地址",
          //   minWidth: 100,
          //   key: "udpIp",
          // },
          // {
          //   title: "UDP端口",
          //   width: 100,
          //   key: "udpPort",
          // },
          // {
          //   title: "修改时间",
          //   width: 180,
          //   key: "updateTime",
          // },
          {
            title: "备注",
            width: 100,
            key: "remark",
          },
          {
            title: "状态",
            width: 100,
            render: (h, { row }) => {
              return (
                <Switch
                  size="large"
                  true-value={1}
                  false-value={
                    +row.status === 0 ? 0 : +row.status === 2 ? 2 : ""
                  }
                  loading={this.statusLoading}
                  value={+row.status}
                  disabled={
                    +row.status == 1
                      ? this.CA("jybk_stop")
                        ? false
                        : true
                      : this.CA("jybk_open")
                      ? false
                      : true
                  }
                  onInput={(val) => this.statusChange(val, row.guid)}
                >
                  <span slot="open">启用</span>
                  <span slot="close">停用</span>
                </Switch>
              );
            },
          },
          {
            title: "操作",
            width: 100,
            render: (h, { row }) => {
              return (
                <div>
                  {this.CA("jybk_edit") && (
                    <a
                      class="iconfont"
                      title="编辑"
                      style="margin-right: 10px"
                      onClick={() => this.edit(row)}
                    >
                      &#xe669;
                    </a>
                  )}
                  {this.CA("jybk_del") && (
                    <Poptip
                      confirm
                      transfer
                      title="确定删除吗?"
                      on-on-ok={() => this.del(row.guid)}
                    >
                      <a class="iconfont" title="删除">
                        &#xe66a;
                      </a>
                    </Poptip>
                  )}
                </div>
              );
            },
          },
        ],
        data: [],
        loading: false,
      },
      config: {
        filter: {
          add: {
            addBtnName: "添加板卡",
            ca: "jybk_add",
          },
          width: 200,
          filterBox: [
            {
              conditionName: "上位一体机",
              component: "input",
              field: "aioName",
              defaultValue: "",
            },
          ],
        },
        page: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },
      },

      modal: {
        show: false,
        title: "",
        submitLoading: false,
      },
      statusLoading: false,

      form: {
        aio: "",
        name: "",
        aiCount: "",
        aoCount: "",
        deviceKey: "",
        diCount: "",
        doCount: "",
        remark: "",
      },
      rules: {
        aio: [{ required: true, message: "请选择一体机" }],
        name: [{ required: true, message: "请填写板卡名称" }],
        deviceKey: [{ required: true, message: "请填写板卡KEY" }],
        aiCount: [
          { required: true, message: "请填写AI通道数" },
          {
            validator(rule, value, callback) {
              if (CU.validateNumber(value)) {
                callback();
                return;
              }
              callback(rule.message);
            },
            message: "请填写正确的AI通道数",
          },
        ],
        aoCount: [
          { required: true, message: "请填写AO通道数" },
          {
            validator(rule, value, callback) {
              if (CU.validateNumber(value)) {
                callback();
                return;
              }
              callback(rule.message);
            },
            message: "请填写正确的AO通道数",
          },
        ],
        diCount: [
          { required: true, message: "请填写DI通道数" },
          {
            validator(rule, value, callback) {
              if (CU.validateNumber(value)) {
                callback();
                return;
              }
              callback(rule.message);
            },
            message: "请填写正确的DI通道数",
          },
        ],
        doCount: [
          { required: true, message: "请填写DO通道数" },
          {
            validator(rule, value, callback) {
              if (CU.validateNumber(value)) {
                callback();
                return;
              }
              callback(rule.message);
            },
            message: "请填写正确的DO通道数",
          },
        ],
      },
      search_data: {},
    };
  },
  methods: {
    search(data) {
      this.config.page.pageNo = 1;
      this.search_data = data;
      this.getList();
    },
    add() {
      this.modal = {
        show: true,
        title: "添加板卡",
        submitLoading: false,
      };
    },
    pageChange(pageNo) {
      this.config.page.pageNo = pageNo;
      this.getList();
    },
    getList() {
      if (!this.CA("jybk_check")) return;
      this.table.loading = true;
      this.$post(this.$api.DEVICES.JYLIST, {
        pageNo: this.config.page.pageNo,
        pageSize: this.config.page.pageSize,
        ...this.search_data,
      })
        .then((res) => {
          this.table.data = res.list;
          this.config.page.total = +res.total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    statusChange(status, guid) {
      this.$post(
        status == "1" ? this.$api.DEVICES.JYOPEN : this.$api.DEVICES.JYSTOP,
        {
          status,
          guid,
        }
      ).then(() => {
        this.$Message.success(status == 1 ? "启用成功" : "停用成功");
        this.getList();
      });
    },
    edit(row) {
      for (let key in this.form) {
        this.form[key] = row[key];
      }
      this.form.guid = row.guid;
      this.form.aio = `${row.aioGuid}/${row.aioName}`;
      this.modal = {
        show: true,
        title: "编辑板卡",
        submitLoading: false,
      };
    },
    del(guid) {
      this.$post(this.$api.DEVICES.JYDEL, {
        guid,
      }).then(() => {
        this.$Message.success("删除成功");
        this.getList();
      });
    },
    modalShow(visible) {
      if (visible) return;
      this.form = {
        aio: "",
        name: "",
        aiCount: "",
        aoCount: "",
        deviceKey: "",
        diCount: "",
        doCount: "",
        remark: "",
      };
      this.$refs.form.resetFields();
    },
    submit() {
      this.$refs.form.validate().then((res) => {
        if (!res) return;
        let params = { ...this.form };
        params.aioGuid = this.form.aio.split("/")[0];
        params.aioName = this.form.aio.split("/")[1];
        delete params.aio;
        this.modal.submitLoading = true;
        this.$post(
          this.form.guid ? this.$api.DEVICES.JYEDIT : this.$api.DEVICES.JYNEW,
          params
        )
          .then(() => {
            this.getList();
            this.modal.show = false;
          })
          .finally(() => {
            this.modal.submitLoading = false;
          });
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.jycfg-page {
  width: 100%;
  height: 100%;
  .table-header {
    display: flex;
    flex-wrap: nowrap;
    padding: 16px;
    .search-pane {
      display: flex;
      flex-wrap: wrap;
      flex-shrink: 1;
      flex-grow: 1;
      span {
        padding-right: 16px;
      }
    }
  }
  .footer {
    text-align: right;
    padding: 16px;
  }
}
/deep/ td.ivu-table-expanded-cell {
  background: #efefef;
}
</style>